/**
 * @module Experience/Plan-Details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
// tslint:disable max-file-line-count

// CORE
import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { Observable, Subject, from, throwError as observableThrowError } from 'rxjs';
import {
  Router,
  ActivatedRoute,
  Params,
  NavigationStart,
  Event,
  NavigationEnd,
} from '@angular/router';
// import { SETTINGS, CHANNELS } from '@environment/settings';

// INTERFACES
import {
  PlanDetailResponse,
  ModuleEnhancement,
} from '@support/api/proxies/responses/api-2123.interface';
import {
  BrowsePlanConfig,
  BrowsePlanAuthorableData,
} from '@core/aem/interfaces/shop/browse-plan.interface';
import { TmoButton } from '@support/shared/widgets/interfaces/button.interface';
import {
  LineDeivceDetails,
  lineTypeEnum,
  TileIdAndLengthToCreateLine,
} from '@experience/shop/product-selector/interfaces/product-selector.interface';
import {
  Cart,
  CartLine,
  CartResponse,
} from '@support/api/proxies/responses/api-cart-response.interface';
import { StaticModal } from '@support/shared/widgets/interfaces/static-modal.interface';

// SERVICES
import { PlanDetailsService } from '@experience/shop/plan-details/services/plan-details.service';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { ContentProviderService } from '@core/aem/services/content-provider.service';
import { CommonUtilService } from '@support/shared/services/common-util.service';
import { TileManagementService } from '@support/shared/services/tile-management.service';
import { PDLBaseComponent } from '@experience/reb-pdl/components/pdl.base.component';
import { PdlService } from '@experience/reb-pdl/services/pdl.service';

// CONSTANTS
import {
  PLAN_DETAILS_CONSTANTS,
  ROUTE_CONSTANTS,
} from '@experience/shop/plan-details/constants/product-details-constant';
import { ORDER_TYPE } from '@experience/shop/shop.constants';

// MODELS
import { PlanDetailsResponseModel } from '@experience/shop/plan-details/models/plan-details-response.model';
import { APIError } from '@support/api/common/error.interface';
import { QueryParams } from '@experience/repdash/interfaces/repdash.interface';
import { PRODUCT_OFFERINGS_CONSTANTS } from '@core/aem/components/product-offerings/product-offerings.constants';
import { CartSupportService } from '@support/cart-support/services/cart-support.service';
import { HARDGOODS_MODULE_COMPONENTS } from '@experience/shop/hardgoods/constants/hardgoods.constants';
import { PERMISSION_CONSTANTS } from '@support/shared/constants/permission.constants';
import { FAN } from '@support/api/proxies/responses/api-2038.interface';
import { takeUntil, catchError, concatMap, tap, finalize } from 'rxjs/operators';
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';
import { DynamicModal } from '@support/shared/widgets/interfaces/dynamic-modal.interface';
import { PdpDataHandlerService } from '@root/shared/services/pdp-data-handler.service';
import { PdlWrapperService } from '@core/services/pdl-wrapper.service';
import { Content } from '@core/aem/models/content.interface';
import { FeatureToggleUtilService } from '@support/shared/services/feature-toggle-util.service';
import { PRODUCT_SELECTOR_ROUTES } from '@experience/shop/product-selector/constants/product-selector.constants';
import { ProductSelectorLandingModel } from '@experience/shop/product-selector/models/product-selector-landing.model';
import { AppConfig } from '@root/app.config';

@Component({
  selector: 'tmo-plan-details',
  templateUrl: './plan-details.component.html',
})
export class PlanDetailsComponent extends PDLBaseComponent implements OnInit, OnDestroy {
  /**
   * Stores plan family Details
   */
  public planFamilyModel: PlanDetailsResponseModel;
  /**
   * Stores module enhancement data
   */
  public planFamilyAuthorableData: ModuleEnhancement[];

  /**
   * Stores value of legal text authorable filtered object
   */
  public legalText: ModuleEnhancement[];
  /**
   * Stores plan family Details
   */
  public zipCode: string;

  /**
   *  TMO Button interface object for Back Button CTA
   */
  public backButton: TmoButton;

  /**
   * Primary CTA for action
   */
  public primaryButton: TmoButton;

  /**
   * Primary CTA to check if it disabled
   */
  public isPrimaryButtonDisabled: boolean;

  /**
   * Stores aem content for plan details page
   */
  public aemContent: BrowsePlanConfig;

  /**
   * stores to check plan Id
   */
  public selectedPlanId: string;

  /**
   * stores selected Family ID
   */
  public selectedFamilyId: string;
  /**
   *  to show existing customer modal
   */
  public showExistingCustomerModal: boolean;
  /**
   * Boolean to show or hide spinner
   */
  public showSpinner: boolean;
  /**
   * Boolean value to show the flow is authorised
   */
  public isAuthFlow: boolean;
  /**
   * Next. Complete. Unsubscribe.
   */
  private ngUnsubscribe: Subject<void>;
  /**
   * Boolean value to check for the assisted
   */
  // public isAssisted: boolean;
  /**
   * Object to store mixedCart modal information
   */
  public mixedCartModal: StaticModal;
  /**
   * Boolean to show mixed cart modal
   */
  public mixedCart: boolean;
  /**
   * Holds current line number to send line number in request payload
   */
  public lineNumber: number;
  /**
   * Holds focused tile id details for activations
   */
  public focusedTileIdDetails: LineDeivceDetails;

  public allowEdit: boolean;
  /**
   * Holds boolean if rep has permission to add second line or not
   */
  public hasPermissionToAddALine: boolean;
  /**
   * Holds page title
   */
  public pageTile: string;
  /**
   * Holds boolean
   */
  public exixtingLinesLoaded: boolean;
  public modal: DynamicModal;
  public isNewCustomer: boolean = false;
  public pdlData: object;
  // private isWebChannel: boolean;
  public eventData: object;
  /**
   * Input value for fractional pages
   */
  public isFractionalPage?: boolean;
  public isNewProductSelectorTemplateEnabled: boolean;
  /**
   * Holds boolean and set to true if max lines are reached
   */
  public isMaxlinesReached: boolean;
  /**
   * skipServiceForPlanFirst is a flag to skip the Service selection for Plan First Flow.
   */
  public skipServiceForPlanFirst: boolean = true;
  /**
   * removeContinue is a flag to remove continue button and redirects to next page on selection for Plan First Flow.
   */
  public removeContinue: boolean = true;
  public productSelectorLandingModel: ProductSelectorLandingModel;
  public planOptionSelectorId: string;
  public numLines: string;
  public isMultiLineEnhancement: boolean;
  public spinnerMessage: string;
  public showSpinnerMessage: boolean;

  private previous: string;
  private current: string;

  public replaceCartModal: StaticModal;

  constructor(
    private planDetailsService: PlanDetailsService,
    private cartSupportService: CartSupportService,
    private commonUtilService: CommonUtilService,
    private contentProviderService: ContentProviderService,
    public activatedRoute: ActivatedRoute,
    private tileManagementService: TileManagementService,
    public router: Router,
    private objectService: ObjectService,
    private stateStoreUtilsService: StateStoreUtilsService,
    private pdpDataHandlerService: PdpDataHandlerService,
    private pdlWrapperService: PdlWrapperService,
    public pdlService: PdlService,
    private featureToggleUtilService: FeatureToggleUtilService,
    private appConfig: AppConfig
  ) {
    super(pdlService, activatedRoute);
    this.ngUnsubscribe = new Subject<void>();
    this.isPrimaryButtonDisabled = true;
    this.isAuthFlow = false;
    this.mixedCart = false;
    this.isNewProductSelectorTemplateEnabled =
      this.featureToggleUtilService.isNewProductSelectorTemplateEnabled();
    this.productSelectorLandingModel = new ProductSelectorLandingModel(
      this.objectService,
      this.stateStoreUtilsService
    );
    this.isMultiLineEnhancement = false;
  }
  /**
   * Component init
   */
  public ngOnInit(): void {
    // this.isAssisted = (SETTINGS.CHANNEL.toLowerCase() !== CHANNELS.WEB);
    // this.isWebChannel = SETTINGS.CHANNEL.toLowerCase() === CHANNELS.WEB.toLowerCase();
    this.pageTile = '';
    this.exixtingLinesLoaded = true;
    this.isAuthFlow = this.stateStoreUtilsService.getCustomerId() !== '';
    this.focusedTileIdDetails = this.stateStoreUtilsService.getFocusedTileLineNonLineItem();
    this.lineNumber = this.objectService.get(
      this.stateStoreUtilsService.getCart(),
      'linesOccupied',
      1
    );
    const routerEventSubscription = this.router.events.subscribe((event: Event) => {
      if (
        event instanceof NavigationStart &&
        this.router.url.split('/')[1] === event.url.split('/')[1]
      ) {
        this.previous = this.router.url.split('/')[2];
        this.current = event.url.split('/')[2];
        this.ngOnDestroy();
      }
      if (
        event instanceof NavigationEnd &&
        this.router.url.split('/')[1] === event.url.split('/')[1]
      ) {
        routerEventSubscription.unsubscribe();
        if (this.previous !== this.current) {
          this.restart();
        }
      }
    });
    this.getExistingLineDetails();
    this.activatedRoute.params
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((planParams: Params) => {
        this.selectedFamilyId = planParams.selectedPlanId;
      });
    this.hasPermissionToAddALine =
      this.cartSupportService.checkForAddALinePermission(PERMISSION_CONSTANTS.BROWSE_PHONES) ||
      this.allowEdit;
    this.createModal();
    const planFamily = this.stateStoreUtilsService.getPlansPDPSelectedPlanId();
    this.isPrimaryButtonDisabled = !(planFamily === this.selectedFamilyId);
    if (this.focusedTileIdDetails) {
      this.isPrimaryButtonDisabled = !(planFamily === this.selectedFamilyId);
    }
    this.loadAEMData();
    if (this.isAuthFlow) {
      this.initApiData(this.selectedFamilyId);
    }
    const customerConfigData = this.stateStoreUtilsService.getCustomerConfigData();
    this.zipCode =
      this.objectService.get(this.stateStoreUtilsService.getBillingAddress(), 'postalCode') ||
      customerConfigData.zip;
    this.selectedPlanId = this.getPlanSelection();
    this.planDetailsService.selectedPlan$
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((selectedPlan: string) => {
        this.isPrimaryButtonDisabled = false;
        this.stateStoreUtilsService.setPlansPDPSelectedPlanId(selectedPlan);
        if (this.removeContinue && selectedPlan) {
          this.onClickPrimaryCTA();
        }
      });
    this.setPDPDataForCart();
    this.isMaxlinesReached = this.cartSupportService.isMaxLineReached();
  }

  private restart(): void {
    this.ngUnsubscribe = new Subject<void>();
    this.showSpinner = false;
    this.isPrimaryButtonDisabled = true;
    this.isAuthFlow = false;
    this.mixedCart = false;
    this.isNewProductSelectorTemplateEnabled =
      this.featureToggleUtilService.isNewProductSelectorTemplateEnabled();
    this.planFamilyModel = null;
    this.previous = '';
    this.current = '';
    this.ngOnInit();
  }
  /**
   * Component clean-up
   */
  public ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.objectService.get(this.focusedTileIdDetails, 'services')) {
      this.focusedTileIdDetails.services = null;
      this.stateStoreUtilsService.setFocusedTileLineNonLineItem(this.focusedTileIdDetails);
    }
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  /**
   * Function called to navigate change order serivices
   */
  public onClickPrimaryCTA(): void {
    this.stateStoreUtilsService.setFamilyId(this.selectedFamilyId);
    // const isWebChannel = SETTINGS.CHANNEL.toLowerCase() ===  CHANNELS.WEB.toLowerCase();
    // if (isWebChannel && !this.isAuthFlow && !this.cartSupportService.isCartNotEmpty(
    //   this.stateStoreUtilsService.getCart(), false)) {
    if (
      !this.isAuthFlow &&
      !this.cartSupportService.isCartNotEmpty(this.stateStoreUtilsService.getCart(), false) &&
      !sessionStorage.getItem('customerSelection')
    ) {
      this.showExistingCustomerModal = true;
      this.isNewCustomer = true;
    } else {
      this.goToNextPage();
    }
  }
  /**
   * Close customer modal on click of cross button
   * @return void
   */
  public closeCustomerModal(): void {
    this.showExistingCustomerModal = false;
  }
  /**
   * Function called to navigate to next page
   */
  public goToNextPage(overrrideIndicator?: boolean): void {
    this.showExistingCustomerModal = false;
    this.showSpinner = true;
    this.subscribeToPlanConfiguration();
  }
  /**
   * Function used to get existing line details
   */
  private getExistingLineDetails(): void {
    if (this.stateStoreUtilsService.getCustomerId()) {
      this.exixtingLinesLoaded = false;
      this.cartSupportService
        .getExistingLineDetails()
        .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
        .subscribe(
          (cart: FAN) => {
            this.exixtingLinesLoaded = true;
            this.hasPermissionToAddALine =
              this.cartSupportService.checkForAddALinePermission(
                PERMISSION_CONSTANTS.BROWSE_PHONES
              ) || this.allowEdit;
          },
          (error: APIError) => {
            this.exixtingLinesLoaded = true;
          }
        );
    }
  }
  private updateDeviceToLineLevel(lineNumber: string): void {
    const sku =
      this.objectService.get(this.focusedTileIdDetails, 'selectedDevice.sku') ||
      this.objectService.get(this.focusedTileIdDetails, 'byodSimData.simSKU');
    const cartItemId =
      this.objectService.get(this.focusedTileIdDetails, 'selectedDevice.cartItemId') ||
      this.objectService.get(this.focusedTileIdDetails, 'byodSimData.cartItemId');
    this.planDetailsService
      .updateCartLevelDeviceToLineLevel(cartItemId, sku, lineNumber)
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe(
        (data: Cart) => {
          this.tileManagementService.deleteLine();
          this.tileManagementService.createTile(lineTypeEnum.LINE, false);
          this.tileManagementService.mapToCartResponse(data);
          this.tileManagementService.setNonLineItemDetails(data);
          this.tileManagementService.getUpdatedData();
          this.showSpinner = false;
          this.router.navigate([
            PRODUCT_OFFERINGS_CONSTANTS.NAVIGATE_TO_PRODUCT_SELECTOR,
            lineNumber,
          ]);
        },
        (error: APIError) => {
          this.showSpinner = false;
        }
      );
  }
  /**
   * Function called to naviageSerivcs page
   */
  public onClickBack(): void {
    this.router.navigate([ROUTE_CONSTANTS.BROWSE_PHONES], { queryParams: { allowEdit: true } });
  }
  /**
   * Function called to selected planId
   */
  public getPlanSelection(): string {
    return this.planDetailsService.getSelectedPlan();
  }
  /**
   * Method to create mixed cart modal
   * @returns void
   */
  private createModal(): void {
    this.mixedCartModal = {
      headerText: this.objectService.get(this.aemContent, 'clearYourCart'),
      bodyText: this.objectService.get(this.aemContent, 'clearOrViewCart'),
      disableDismiss: true,
      disableEsc: true,
      modalName: 'mixed-cart-modal',
      buttons: [
        {
          id: this.objectService.get(this.aemContent, 'continue'),
          type: 'submit',
          name: this.objectService.get(this.aemContent, 'continue'),
          class: 'btn btn-primary',
        },
        {
          id: 'ViewCart',
          type: 'cancel',
          name: this.objectService.get(this.aemContent, 'viewCart'),
          class: 'btn btn-secondary',
        },
      ],
      toggleModalEmitter: new EventEmitter(),
      dismissableMask: false,
    };
    this.replaceCartModal = {
      headerText: '',
      bodyText: '',
      disableDismiss: true,
      disableEsc: true,
      modalName: 'replace-your-cart',
      buttons: [
        {
          id: 'continue',
          type: 'submit',
          name: '',
          class: 'btn btn-primary',
        },
        {
          id: 'ViewCart',
          type: 'cancel',
          name: '',
          class: 'btn btn-secondary',
        },
      ],
      toggleModalEmitter: new EventEmitter(),
      dismissableMask: false,
    };
  }
  /**
   * Method to handle the click events for mixed cart modal
   * @returns void
   */
  public handleClickEventMixedCart(event: Event): void {
    this.mixedCartModal.toggleModalEmitter.emit({
      open: false,
      close: true,
    });
    const key = 'id';
    const id = event[key];
    if (id === this.objectService.get(this.aemContent, 'continue')) {
      this.goToNextPage(true);
    } else if (id === this.objectService.get(this.aemContent, 'viewCart')) {
      this.mixedCart = false;
      this.router.navigate([PLAN_DETAILS_CONSTANTS.CART_URL]);
    }
  }
  /**
   * Load AEM Data
   * @return void
   */
  private loadAEMData(): void {
    this.showSpinner = true;
    this.planDetailsService
      .getAemContent()
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((data: BrowsePlanConfig) => {
        if (data) {
          this.aemContent = data;
          this.spinnerMessage = this.aemContent.spinnerMessage;
          this.mixedCartModal.headerText = this.aemContent.clearYourCart;
          this.mixedCartModal.bodyText = this.aemContent.clearOrViewCart;
          this.mixedCartModal.buttons[0].id = this.aemContent.continue;
          this.mixedCartModal.buttons[0].name = this.aemContent.continue;
          this.mixedCartModal.buttons[1].id = this.aemContent.viewCart;
          this.mixedCartModal.buttons[1].name = this.aemContent.viewCart;
          this.replaceCartModal.headerText = this.aemContent.replaceCartHeader;
          this.replaceCartModal.bodyText = this.aemContent.replaceCartBody;
          this.replaceCartModal.buttons[0].name = this.aemContent.replaceCart;
          this.replaceCartModal.buttons[1].name = this.aemContent.viewCart;
          this.activatedRoute.queryParams
            .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
            .subscribe((params: QueryParams) => {
              const multiLineScenario = this.stateStoreUtilsService.getMultiLineScenario();
              this.allowEdit =
                (!multiLineScenario && this.objectService.get(params, 'allowEdit') === 'true') ||
                !this.objectService.get(this.focusedTileIdDetails, 'isLineSetupCompleted', true);
              if (multiLineScenario) {
                this.stateStoreUtilsService.setPlansPDPSelectedPlanId('');
              }
              if (!this.isAuthFlow) {
                this.planOptionSelectorId = params['planOptionSelectorId'];
                this.numLines = params['Num_Lines'];
                this.isMultiLineEnhancement =
                  this.appConfig.getConfig('isMultilineEnabled') &&
                  !!(this.planOptionSelectorId && Number(this.numLines));
                if (this.isMultiLineEnhancement) {
                  this.stateStoreUtilsService.setMultiLineScenario(true);
                  this.isNewCustomer = !sessionStorage.getItem('customerSelection');
                  this.cartSupportService.promotionsCartLoaded$.subscribe((data: boolean) => {
                    this.showSpinner = false;
                    if (
                      !this.cartSupportService.isCartNotEmpty(
                        this.stateStoreUtilsService.getCart(),
                        true
                      )
                    ) {
                      this.showExistingCustomerModal = this.isNewCustomer;
                      if (!this.showExistingCustomerModal) {
                        this.subscribeToPlanConfiguration();
                      }
                    } else {
                      this.replaceCartModal.toggleModalEmitter.emit({ open: true, close: false });
                    }
                  });
                } else {
                  this.initApiData(this.selectedFamilyId);
                }
              }
              if (!this.removeContinue) {
                const planOptionSelectorId = this.objectService.get(params, 'planOptionSelectorId');
                // if (planOptionSelectorId && (!this.isAssisted)) {
                if (planOptionSelectorId) {
                  this.stateStoreUtilsService.setPlansPDPSelectedPlanId(planOptionSelectorId);
                }
              }
            });
          this.initButtons();
        }
      });
  }
  /**
   * Method to get the backbutton and continue button values from AEM
   * @returns: void
   */
  private initButtons(): void {
    let primaryCTAText = '';
    const custConfigData = this.stateStoreUtilsService.getCustomerConfigData();
    primaryCTAText = this.objectService.get(this.aemContent, 'select');
    this.backButton = {
      name: this.objectService.get(this.aemContent, 'back'),
      id: PLAN_DETAILS_CONSTANTS.BACK_ID,
      class: PLAN_DETAILS_CONSTANTS.CLASS,
      type: PLAN_DETAILS_CONSTANTS.TYPE,
    };
    this.primaryButton = {
      name: primaryCTAText,
      id: PLAN_DETAILS_CONSTANTS.CHANGE_EXISTING_PLAN_ID,
      class: PLAN_DETAILS_CONSTANTS.CLASS_CPS,
      type: PLAN_DETAILS_CONSTANTS.TYPE,
    };
  }
  /**
   * Api 2123 calling to retrieve pdp-plan
   * @return void
   */
  private initApiData(selectedFamilyId: string): void {
    this.showSpinner = true;
    this.planDetailsService
      .initApiData(selectedFamilyId, this.lineNumber)
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((data: PlanDetailResponse) => {
        this.showSpinner = false;
        const getConfigurableData = <ConfigData>(
          this.contentProviderService.getConfigurableData(
            this.objectService.get(data, 'model-view.model.model-data.module-enhancements')
          )
        );
        this.pageTile = this.objectService.get(getConfigurableData, 'pageTitle', '');
        const response = this.objectService.get(
          data,
          'model-view.model.model-data.module-enhancements'
        );
        this.planFamilyModel = this.createPlanDetailsResponseModel(data);
        this.planDetailsService.setModelInStateStore(this.planFamilyModel);
        const authPDPData = <ModuleEnhancement[]>(
          this.contentProviderService.getAuthorableData(response)
        );
        this.planFamilyAuthorableData = authPDPData.filter((authData: BrowsePlanAuthorableData) => {
          return authData.uiComponent === HARDGOODS_MODULE_COMPONENTS.CONTAINER_HOLDER;
        });
        this.legalText = authPDPData.filter((legalValue: BrowsePlanAuthorableData) => {
          return legalValue.uiComponent === HARDGOODS_MODULE_COMPONENTS.LEGAL_TEXT;
        });
        // if (this.isWebChannel) {
        const aemData: Content = this.objectService.get(data, 'model-view');
        const contentUrl = this.router.url.split('?')[0];
        this.pdlWrapperService.trackData(contentUrl, 'PAGE_LOAD', aemData);
        this.pdlService.triggerCustomEvent(this.pdlPageComponentId, 'pageLoad');
        // }
      });
  }
  /**
   * Create Plan Details Response Model
   * @param response of type PlanDetailResponse
   * @returns PlanDetailsResponseModel
   */
  private createPlanDetailsResponseModel(response: PlanDetailResponse): PlanDetailsResponseModel {
    const lineId = this.planDetailsService.getLineId();
    const planDetailsModel = new PlanDetailsResponseModel(response, lineId, true);
    return planDetailsModel;
  }

  private triggerEvent(): void {
    if (this.isNewCustomer) {
      this.triggerCartAddEvent(true, 'New Customer');
    } else {
      this.triggerCartAddEvent(false, 'Select');
    }
  }

  private triggerCartAddEvent(modal: boolean, ctaName: string): void {
    if (modal) {
      this.modal = {
        modalName: 'Are you an existing customer',
      };
    }
    const cart = this.stateStoreUtilsService.getCart();
    const selectedPlanId = this.stateStoreUtilsService.getPlansPDPSelectedPlanId();
    const productInfo = this.pdpDataHandlerService.fetchProductInfo(cart, selectedPlanId);
    this.pdlData = {
      ctaName: ctaName,
      product: productInfo,
    };
    this.setPDPDataForCart();
    this.pdlService.triggerCustomEvent(this.pdlPageComponentId, 'cartAdd');
  }

  private setPDPDataForCart(): void {
    const cart = this.stateStoreUtilsService.getCart();
    const isCartEmpty = !this.cartSupportService.isCartNotEmpty(cart);
    // if (this.isWebChannel && !isCartEmpty) {
    if (!isCartEmpty) {
      this.pdpDataHandlerService.updateCartForPDL(cart, isCartEmpty);
    }
  }

  private triggerErrorEvent(code: string, errorMessage: string): void {
    // if (this.isWebChannel) {

    this.eventData = {
      eventInfo: {
        eventAction: 'click',
        eventType: 'error',
      },
      error: [
        {
          errorText: errorMessage,
          errorCode: code,
        },
      ],
    };
    this.pdlService.triggerCustomEvent(this.pdlPageComponentId, 'click');
    // }
  }
  /**
   * Navigate to Landing page
   */
  public navigateHome(): void {
    const route = this.stateStoreUtilsService.getCustomerId()
      ? ROUTE_CONSTANTS.ACCOUNT_LANDING
      : this.cartSupportService.getHomePage();
    if (route.match(new RegExp(ROUTE_CONSTANTS.HTTP_URL, 'i'))) {
      window.location.href = route;
    } else {
      this.router.navigate([route]);
    }
  }

  private planConfigurationApi(): Observable<CartResponse> {
    const selectedPlanId = this.isMultiLineEnhancement
      ? this.planOptionSelectorId
      : this.stateStoreUtilsService.getPlansPDPSelectedPlanId();
    const transactionTypes = !this.stateStoreUtilsService.getCustomerId()
      ? ORDER_TYPE.ACTIVATION
      : ORDER_TYPE.ADDALINE;
    const accountId = this.stateStoreUtilsService.getAddFan()
      ? ''
      : this.stateStoreUtilsService.getAccountId();
    const planConfigurations = [];
    const numLines = this.isMultiLineEnhancement ? Number(this.numLines) : 1;
    for (let line = 1; line <= numLines; line++) {
      const lineNumber = this.getLineNumber();
      planConfigurations.push(
        this.planDetailsService.putSelectedPlanToCart(
          selectedPlanId,
          lineNumber,
          true,
          transactionTypes,
          accountId
        )
      );
    }
    return from([...planConfigurations]).pipe(
      concatMap((response) => {
        return response;
      }),
      catchError((error: APIError[]) => {
        this.triggerErrorEvent(error[0].code, error[0].userMessage);
        return observableThrowError(error);
      }),
      tap({
        complete: () => {
          if (this.stateStoreUtilsService.getMultiLineScenario()) {
            this.router.navigate([PRODUCT_SELECTOR_ROUTES.CART]);
          }
        },
      })
    );
  }

  private subscribeToPlanConfiguration(): void {
    this.showSpinnerMessage =
      !this.planFamilyModel && this.planOptionSelectorId && this.numLines ? true : false;
    this.showSpinner = true;
    const isNonLineTile =
      this.objectService.get(this.focusedTileIdDetails, 'lineTileType') === lineTypeEnum.NONLINE;
    let lineNumber;
    const isMultiLineScenario = this.stateStoreUtilsService.getMultiLineScenario();
    if (!isMultiLineScenario) {
      lineNumber = this.getLineNumber();
    }
    this.planConfigurationApi()
      .pipe(
        takeUntil(this.ngUnsubscribe.asObservable()),
        catchError((error: APIError[]) => {
          if (error.length && error[0].code === PLAN_DETAILS_CONSTANTS.MIXED_CART_ERROR) {
            this.mixedCart = true;
            this.mixedCartModal.toggleModalEmitter.emit({ open: true, close: false });
          }
          this.triggerErrorEvent(error[0].code, error[0].userMessage);
          return observableThrowError(error);
        }),
        finalize(() => {
          if (isNonLineTile && !isMultiLineScenario) {
            this.updateDeviceToLineLevel(lineNumber);
          } else {
            this.showSpinner = false;
          }
        })
      )
      .subscribe(
        (response: CartResponse) => {
          if (!isMultiLineScenario) {
            if (!isNonLineTile) {
              if (!this.allowEdit) {
                this.tileManagementService.createTile();
              }
              this.tileManagementService.mapToCartResponse(response.cart);
              this.focusedTileIdDetails =
                this.stateStoreUtilsService.getFocusedTileLineNonLineItem();
              this.triggerEvent();
              if (this.skipServiceForPlanFirst) {
                this.router.navigate([PRODUCT_SELECTOR_ROUTES.CART]);
              } else {
                this.router.navigate([
                  PRODUCT_OFFERINGS_CONSTANTS.NAVIGATE_TO_PRODUCT_SELECTOR,
                  lineNumber,
                ]);
              }
            }
          } else {
            const existingTilesList = this.stateStoreUtilsService.getTileIdList(lineTypeEnum.LINE);
            if (response.cart.lines.length === existingTilesList.length) {
              response.cart.lines.forEach((cartLine: CartLine, index: number) => {
                const tileDetails: TileIdAndLengthToCreateLine = { tileId: '', currentLength: 0 };
                if (existingTilesList.includes(cartLine.id)) {
                  tileDetails.tileId = existingTilesList[index];
                  tileDetails.currentLength = existingTilesList.length;
                  this.productSelectorLandingModel.createTile(
                    tileDetails,
                    lineTypeEnum.LINE,
                    false,
                    cartLine
                  );
                  this.focusedTileIdDetails =
                    this.stateStoreUtilsService.getFocusedTileLineNonLineItem();
                }
              });
              this.tileManagementService.mapToCartResponse(response.cart);
            }
          }
        },
        (error: APIError[]) => {
          this.showSpinner = false;
          if (error.length && error[0].code === PLAN_DETAILS_CONSTANTS.MIXED_CART_ERROR) {
            this.mixedCart = true;
            this.mixedCartModal.toggleModalEmitter.emit({ open: true, close: false });
          }
          this.triggerErrorEvent(error[0].code, error[0].userMessage);
        }
      );
  }

  private getLineNumber(): string {
    const isNonLineTile =
      this.objectService.get(this.focusedTileIdDetails, 'lineTileType') === lineTypeEnum.NONLINE;
    let lineNumber = '';
    if (this.stateStoreUtilsService.getMultiLineScenario()) {
      lineNumber = this.objectService.get(
        this.tileManagementService.generateTile(lineTypeEnum.LINE, false),
        'tileId'
      );
    } else {
      if (isNonLineTile || !this.focusedTileIdDetails || !this.allowEdit) {
        lineNumber = this.objectService.get(
          this.tileManagementService.generateTile(lineTypeEnum.LINE, true),
          'tileId'
        );
      } else {
        lineNumber = this.objectService.get(this.focusedTileIdDetails, 'tileId');
      }
    }
    return lineNumber;
  }

  public handleRevertCart(event: EventTarget): void {
    const target = event as HTMLElement;
    if (target.id === PLAN_DETAILS_CONSTANTS.CONTINUE) {
      this.cartSupportService
        .deleteCart()
        .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
        .subscribe(
          () => {
            this.subscribeToPlanConfiguration();
          },
          (error: APIError[]) => {
            if (error.length && error[0].code) {
              this.triggerErrorEvent(error[0].code, error[0].userMessage);
            }
          }
        );
    } else {
      this.router.navigate([PRODUCT_SELECTOR_ROUTES.CART]);
    }
  }
}
